const STORAGE_PREFIX = 'wetree.billing.activating:';

/** Mark a family as awaiting webhook confirmation after a successful Paddle checkout. */
export function markBillingActivating(familyId: string): void {
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${familyId}`, String(Date.now()));
  } catch {
    // sessionStorage may be unavailable; successUrl query param is the fallback
  }
}

/** True if checkout completed for this family and we have not yet shown the activating UX. */
export function hasBillingActivating(familyId: string): boolean {
  try {
    return sessionStorage.getItem(`${STORAGE_PREFIX}${familyId}`) != null;
  } catch {
    return false;
  }
}

/** Clear the pending-activating flag after the UX has been shown / dismissed. */
export function clearBillingActivating(familyId: string): void {
  try {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${familyId}`);
  } catch {
    // ignore
  }
}

export function billingActivatingSuccessPath(familyId: string): string {
  return `/families/${familyId}/overview?billing=activating`;
}

export function billingActivatingSuccessUrl(familyId: string): string {
  return `${window.location.origin}${billingActivatingSuccessPath(familyId)}`;
}
